import React, { useContext } from "react";
import { Card, Table, Alert } from "@themesberg/react-bootstrap";
import { Context } from "../CashFlow";

const formatMoney = (value) => {
  const amount = Number(value) || 0
  if (amount === 0) return '-'
  return new Intl.NumberFormat('vi-VN').format(amount)
}

const formatDate = (dateKey) => {
  if (!dateKey) return ''
  const [year, month, day] = dateKey.split('-')
  return `${day}/${month}/${year}`
}

const MoneyCell = ({ value, className = '' }) => (
  <td className={`text-end ${className}`}>{formatMoney(value)}</td>
)

const DataRow = ({ label, row, isTotal }) => (
  <tr className={isTotal ? 'fw-bold bg-light' : ''}>
    <td className="text-center">{label}</td>
    <MoneyCell value={row.openMain} />
    <MoneyCell value={row.openReward} />
    <MoneyCell value={row.charge} className="text-success" />
    <MoneyCell value={row.payReward} className="text-success" />
    <MoneyCell value={row.refundTicket} className="text-success" />
    <MoneyCell value={row.buy} className="text-danger" />
    <MoneyCell value={row.withdraw} className="text-danger" />
    <MoneyCell value={row.transfer} />
    <MoneyCell value={row.otherMain} />
    <MoneyCell value={row.otherReward} />
    <MoneyCell value={row.closeMain} />
    <MoneyCell value={row.closeReward} />
  </tr>
)

const GROUP_HEADER_CLASS = "border-bottom text-center py-2 text-uppercase small fw-bold text-muted"
const SUB_HEADER_CLASS = "border-bottom text-center py-2 small fw-bold text-muted"

const _Table = () => {
  const { state } = useContext(Context);

  if (state.error) {
    return (
      <Alert variant="warning" className="mb-4">{state.error}</Alert>
    )
  }

  const data = state.data
  const days = data?.days || []

  const totalRow = data ? {
    openMain: data.openMain,
    openReward: data.openReward,
    closeMain: data.closeMain,
    closeReward: data.closeReward,
    ...data.totals
  } : null

  return (
    <Card border="light" className="shadow-sm mb-4 border-0">
      {data?.user && (
        <Card.Header className="border-0 pb-0">
          <span className="text-muted">Khách hàng: </span>
          <strong>{data.user.name}</strong>{' '}
          <strong className="text-primary">{data.user.phone}</strong>
        </Card.Header>
      )}
      <Card.Body className="p-0">
        <div className="table-responsive">
          <Table className="table-centered table-nowrap mb-0 rounded align-middle" hover bordered>
            <thead className="bg-white">
              <tr>
                <th rowSpan={2} className={GROUP_HEADER_CLASS}>Ngày</th>
                <th colSpan={2} className={GROUP_HEADER_CLASS}>Tồn đầu</th>
                <th colSpan={3} className={GROUP_HEADER_CLASS}>Tăng trong kỳ</th>
                <th colSpan={2} className={GROUP_HEADER_CLASS}>Giảm trong kỳ</th>
                <th rowSpan={2} className={GROUP_HEADER_CLASS}>Chuyển ví thưởng sang ví mua</th>
                <th colSpan={2} className={GROUP_HEADER_CLASS}>Khác / Điều chỉnh</th>
                <th colSpan={2} className={GROUP_HEADER_CLASS}>Tồn cuối</th>
              </tr>
              <tr>
                <th className={SUB_HEADER_CLASS}>Ví chơi</th>
                <th className={SUB_HEADER_CLASS}>Ví thưởng</th>
                <th className={SUB_HEADER_CLASS}>Nạp ví</th>
                <th className={SUB_HEADER_CLASS}>Trả thưởng</th>
                <th className={SUB_HEADER_CLASS}>Hoàn / hủy vé</th>
                <th className={SUB_HEADER_CLASS}>Mua vé</th>
                <th className={SUB_HEADER_CLASS}>Rút về TK NH</th>
                <th className={SUB_HEADER_CLASS}>Ví chơi</th>
                <th className={SUB_HEADER_CLASS}>Ví thưởng</th>
                <th className={SUB_HEADER_CLASS}>Ví chơi</th>
                <th className={SUB_HEADER_CLASS}>Ví thưởng</th>
              </tr>
            </thead>
            <tbody>
              {totalRow && days.length > 0 && (
                <DataRow label="TC" row={totalRow} isTotal />
              )}
              {days.map((row) => (
                <DataRow key={`cash-flow-${row.date}`} label={formatDate(row.date)} row={row} />
              ))}
              {days.length === 0 && (
                <tr>
                  <td colSpan="13" className="text-center py-5 text-muted">
                    <div className="fs-5">Chưa có dữ liệu</div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default React.memo(_Table)
